document.addEventListener("DOMContentLoaded", function () {
  const COUNTDOWN_KEY = "limited_deal_timer_deadline_1hr"; // new key
  const countdownDuration = 1 * 60 * 60 * 1000; // 1 hour in milliseconds
  let deadline = localStorage.getItem(COUNTDOWN_KEY);

  if (!deadline || Date.now() > parseInt(deadline)) {
    deadline = Date.now() + countdownDuration;
    localStorage.setItem(COUNTDOWN_KEY, deadline);
  } else {
    deadline = parseInt(deadline);
  }

  function updateCountdown() {
    const now = new Date().getTime();
    const t = deadline - now;

    if (t <= 0) {
      document.getElementById("days").textContent = 0;
      document.getElementById("hours").textContent = "00";
      document.getElementById("minutes").textContent = "00";
      document.getElementById("seconds").textContent = "00";
      return;
    }

    const days = Math.floor(t / (1000 * 60 * 60 * 24));
    const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((t % (1000 * 60)) / 1000);

    document.getElementById("days").textContent = days;
    document.getElementById("hours").textContent = String(hours).padStart(2, '0');
    document.getElementById("minutes").textContent = String(minutes).padStart(2, '0');
    document.getElementById("seconds").textContent = String(seconds).padStart(2, '0');
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});
